export default "__VITE_ASSET__CZesMQVG__"